import { Typography } from 'src/components/PulseUI';
import React from 'react';

const SecondaryAddressCell = ({ row }) => {
  const secondaryAddresses =
    row?.secondary_addresses || row?.secondary_addresses_v2;

  return (
    <div className="w-full">
      {secondaryAddresses?.map((address, index) => {
        const line2 = address.address_line_2
          ? `${address.address_line_2}, `
          : '';
        return (
          <Typography
            key={index}
            variant="body2"
            className="w-full overflow-hidden text-ellipsis pr-2"
          >
            {`${address.address_line_1}, ${line2} ${address.city}, ${address.state}, ${address.zip_code}`}
          </Typography>
        );
      })}
    </div>
  );
};

export default SecondaryAddressCell;
